<template>
  <el-card v-loading="isLoading" shadow="always">
    <template #header>
      <el-row type="flex" justify="space-between" align="center">
        <h4>Alterações de Preço</h4>
        <el-col :md="12">
          <el-row type="flex" justify="end">
            <el-button type="primary" size="medium" @click="openModal">
              Nova alteração de preço
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </template>

    <el-table
      stripe
      :cell-style="() => 'text-align:center;'"
      :data="priceChanges?.data"
      @row-click="openViewModal"
      style="width: 100%; z-index: 0"
    >
      <el-table-column prop="user.name" label="usuário criador"> </el-table-column>
      <el-table-column label="percentual">
        <template #default="scope">
          {{ formatPercent(scope.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column label="data de criação">
        <template #default="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @update:current-page="currentPage = $event"
      :current-page="currentPage"
      background
      layout="prev, pager, next"
      :page-count="priceChanges?.lastPage"
    >
    </el-pagination>
  </el-card>
  <product-price-change-modal
    :showModal="showModal"
    :mode="modalMode"
    :viewMountedProducts="selectedChange?.products || []"
    @close-modal="closeModal"
    @saved="fetchPriceChanges"
  ></product-price-change-modal>
</template>

<script>
import ProductPriceChangeService from "../services/product_price_changes";
import { numberFormatter, dateFormatterShort } from "../utils/formatters";
import { notifyError } from "../utils/notifiers";
import ProductPriceChangeModal from "./modals/ProductPriceChangeModal.vue";

export default {
  name: "ProductPriceChanges",
  components: { ProductPriceChangeModal },
  data: () => ({
    isLoading: false,
    priceChanges: null,
    currentPage: 1,
    showModal: false,
    modalMode: "create",
    selectedChange: null,
  }),
  mounted() {
    this.fetchPriceChanges();
  },
  methods: {
    formatPercent(value) {
      return `${numberFormatter.format(Number(value || 0))}%`;
    },
    formatDate(value) {
      return dateFormatterShort.format(value);
    },
    async fetchPriceChanges() {
      this.isLoading = true;
      const { productPriceChanges, error } = await ProductPriceChangeService().index({
        pagination: this.currentPage,
      });
      if (error) notifyError();
      this.priceChanges = productPriceChanges;
      this.isLoading = false;
    },
    openModal() {
      this.modalMode = "create";
      this.selectedChange = null;
      this.showModal = true;
    },
    openViewModal(row) {
      this.modalMode = "view";
      this.selectedChange = row || null;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedChange = null;
      this.modalMode = "create";
    },
  },
  watch: {
    currentPage() {
      this.fetchPriceChanges();
    },
  },
};
</script>
